const PLATFORM_PERMISSION_PREFIX = "PLATFORM_";
export const ADMIN_FEEDBACK_INFORMATION =
  `${PLATFORM_PERMISSION_PREFIX}ADMIN_FEEDBACK_INFORMATION`;